import _ from '@luna/lodash';
import { isValidDate } from '@luna/date';

import type { TransactionPredicate } from './types';

export const hasField =
    (propertyPath: string): TransactionPredicate =>
    (transaction) => {
        // noinspection JSDeprecatedSymbols
        const field = _.get(transaction, propertyPath);
        // noinspection JSDeprecatedSymbols
        return (
            !_.isEmpty(field) || field === true || typeof field === 'number' || isValidDate(field)
        );
    };
